import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, withModifiers as _withModifiers, createElementBlock as _createElementBlock, Fragment as _Fragment, vShow as _vShow, withDirectives as _withDirectives, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "min-h-100 relative" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "flex gap-3 items-center" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Close"),
  /*#__PURE__*/_createElementVNode("div", { class: "rounded-md button-bg rounded-md px-1 py-0.5" }, " Esc ")
], -1)
const _hoisted_3 = { class: "flex items-center px-1 gap-2" }
const _hoisted_4 = { class: "flex gap-3 items-center" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "rounded-md button-bg rounded-md px-1 py-0.5" }, " U ", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "flex items-center px-1 gap-2" }, " Delete ", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "flex gap-3 items-center" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Delete"),
  /*#__PURE__*/_createElementVNode("div", { class: "rounded-md button-bg rounded-md px-1 py-0.5" }, " D ")
], -1)
const _hoisted_8 = {
  key: 0,
  class: "absolute top-0 left-0 right-0 bottom-0 flex flex-col gap-4 justify-center items-center"
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", null, " Loading message details... ", -1)

import { Contact } from '@/contacts';
import {
	ConversationEmailMessage,
	EmailShortMessage,
	useConversations,
	useMessages
} from '@/inbox/composition';
import {
	SvgIcon,
	UiLoader,
	BorderedButton,
	Tooltip
} from '@/ui-kit';
import { useToggle } from '@vueuse/shared';
import { computed } from 'vue';
import EmailFullMessage from './EmailFullMessage.vue';
import MessageDetailsHeader from './MessageDetailsHeader.vue';
import MessagePreview from './MessagePreview.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ChildEmail',
  props: {
    email: null,
    contact: null,
    isExpanded: { type: Boolean }
  },
  emits: ["expand", "close"],
  setup(__props: any) {

const props = __props as {
	email: EmailShortMessage;
	contact: Contact;
	isExpanded: boolean;
};





const {
	loadMessageDetails,
	getSelectedMessage,
	deleteMessage,
	setMessageRead,
	setMessageUnread
} = useMessages();
const { selectedConversation } = useConversations();

const [loading, setLoading] = useToggle(true);

const messageDetails = computed(() =>
	getSelectedMessage(props.email.uid)
);

async function openMessage() {
	if (!loading.value || messageDetails.value) {
		return;
	}

	await loadMessageDetails(
		selectedConversation.value!.id.toString(),
		props.email.uid
	);
	setLoading(false);
}

function toggleRead() {
	if (props.email.read_at) {
		return setMessageUnread(
			props.email.conversation_id,
			props.email as any
		);
	}

	setMessageRead(
		props.email.conversation_id,
		props.email as any
	);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["border flex flex-col border-solid rounded-md", __props.isExpanded ? 'shadow-xl' : 'shadow-lg'])
  }, [
    (!__props.isExpanded)
      ? (_openBlock(), _createBlock(MessagePreview, {
          key: 0,
          isChild: "",
          justPreview: "",
          onClick: _cache[0] || (_cache[0] = ($event: any) => {
				openMessage();
				_ctx.$emit('expand');
			}),
          message: __props.email,
          class: "!pr-4"
        }, null, 8, ["message"]))
      : _createCommentVNode("", true),
    _withDirectives(_createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        class: "flex items-center gap-2 p-2",
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('close')))
      }, [
        _createVNode(_unref(Tooltip), { placement: "bottom" }, {
          popper: _withCtx(() => [
            _hoisted_2
          ]),
          default: _withCtx(() => [
            _createElementVNode("button", {
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('close'))),
              class: "mr-1.5 cursor-pointer h-7 px-1.5 rounded flex items-center justify-center transition hover:shadow hover:bg-gray-theme-400 hover:bg-opacity-15 text-gray-theme-500"
            }, [
              _createVNode(_unref(SvgIcon), {
                name: "CloseIcon",
                class: "h-4.5 w-4.5"
              })
            ])
          ]),
          _: 1
        }),
        (
						__props.email.content.direction ===
						'incoming'
					)
          ? (_openBlock(), _createBlock(_unref(Tooltip), {
              key: 0,
              placement: "bottom",
              class: "ml-auto"
            }, {
              popper: _withCtx(() => [
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("span", null, _toDisplayString(__props.email.read_at
									? 'Mark as unread'
									: 'Mark as read'), 1),
                  _hoisted_5
                ])
              ]),
              default: _withCtx(() => [
                _createVNode(_unref(BorderedButton), { onClick: toggleRead }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_3, _toDisplayString(__props.email.read_at
									? 'Mark as unread'
									: 'Mark as read'), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        _createVNode(_unref(Tooltip), { placement: "bottom" }, {
          popper: _withCtx(() => [
            _hoisted_7
          ]),
          default: _withCtx(() => [
            _createVNode(_unref(BorderedButton), {
              onClick: _withModifiers(_unref(deleteMessage), ["stop"])
            }, {
              default: _withCtx(() => [
                _hoisted_6
              ]),
              _: 1
            }, 8, ["onClick"])
          ]),
          _: 1
        })
      ]),
      (!_unref(messageDetails))
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
            _hoisted_9,
            _createVNode(_unref(UiLoader))
          ]))
        : (_unref(messageDetails))
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createVNode(MessageDetailsHeader, {
                class: "mt-4",
                message: _unref(messageDetails),
                contact: __props.contact
              }, null, 8, ["message", "contact"]),
              _createVNode(EmailFullMessage, { message: _unref(messageDetails) }, null, 8, ["message"])
            ], 64))
          : _createCommentVNode("", true)
    ], 512), [
      [_vShow, __props.isExpanded]
    ])
  ], 2))
}
}

})